import {PayoffV2Status} from "../../types";

export type WithdrawTrackingStep = { state: 'done' | 'active' | 'future'; title: string; subtitle?: string };

export const buildPayoutTrackingSteps = (status: PayoffV2Status): WithdrawTrackingStep[] => {
  const payoutAccepted = status === 'PAID';

  return [
    {state: 'done', title: 'Confirmed', subtitle: 'Just now'},
    {
      state: payoutAccepted ? 'done' : 'active', title: payoutAccepted ? 'Payout accepted' : 'Payout processing',
      subtitle: payoutAccepted ? 'Complete' : 'In progress'
    },
    {
      state: payoutAccepted ? 'active' : 'future',
      title: payoutAccepted ? 'Delivery pending' : 'Delivery details pending',
      subtitle: payoutAccepted ? 'Timing depends on the payout provider' : 'Check Transaction History for updates'
    }
  ];
};
